import { NestedTableNodeTree } from 'ui/treeView';
import {
  CampaignBreakdownResp,
  CampaignIdToMetadataMap,
  RowTypes,
  Sort,
  ThumbnailResp,
} from '../types';
import { Row } from '../components';
import { CampaignNameWithCaption } from '../components/CampaignNameWithCaption';
import { sortRows } from './sortRows';

type CampaignData = {
  name: string;
  type: string;
  state: string;
  thumbnail?: string;
} & CampaignBreakdownResp;

const getCampaignBreakdownRow = (campaignData: CampaignData) => {
  const {
    id,
    name,
    type,
    state,
    thumbnail,
    metrics: { TotalSent, TotalClicks, UniqueClicks, ClickRate },
  } = campaignData;
  const CampaignNameWithMetadata = (
    <CampaignNameWithCaption
      thumbnailSrc={thumbnail}
      value={name}
      metadata={{ campaignState: state, campaignType: type }}
      campaignId={id}
    />
  );
  return {
    id,
    row: (
      <Row
        cells={[CampaignNameWithMetadata, TotalSent, TotalClicks, UniqueClicks, ClickRate]}
        isCampaign
      />
    ),
  };
};

export const getCampaignBreakdownRows = (
  breakdown: CampaignBreakdownResp[] | undefined,
  baseLevelRow: NestedTableNodeTree,
  campaignIdToMetadataMap: CampaignIdToMetadataMap,
  thumbnails: ThumbnailResp,
  sort: Sort,
) => {
  if (!breakdown) return undefined;

  const campaignData = breakdown.map((camp) => {
    const { campaignName, campaignType, campaignState, templateId } =
      campaignIdToMetadataMap[camp?.id?.toString()] || {};
    return {
      name: campaignName,
      type: campaignType,
      state: campaignState,
      thumbnail: thumbnails[templateId],
      ...camp,
    };
  });

  const nestedCampaignRows = sortRows(campaignData, sort, RowTypes.Campaign).map((camp) =>
    getCampaignBreakdownRow(camp),
  );
  return { ...baseLevelRow, nestedData: nestedCampaignRows };
};
